export default "__VITE_ASSET__991c49a0__"